// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/backgrounds/sea.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/backgrounds/winner-2p.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/backgrounds/defeated-1p.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/backgrounds/winner-1p.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/backgrounds/home.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/backgrounds/battle.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/backgrounds/deploy-fleet.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/images/hit_miss_marks/hit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/images/hit_miss_marks/miss.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Passero+One&family=Labrada&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
::backdrop {
  /* Colors (palette)*/
  --col-black: rgb(20, 20, 20);
  --col-black-alpha: rgb(20, 20, 20, 0.5);
  --col-grey: rgb(200, 200, 200, 0.8);
  --col-white: rgb(255, 255, 255);
  --col-orange-dark: rgb(224, 60, 36);
  --col-orange-light: rgb(249, 167, 34);
  --col-orange: rgb(245, 117, 16);
  --col-darker-sea-blue: rgb(1, 64, 79); /*014e65*/
  --col-sea-blue: rgb(6, 70, 84);
  --col-lighter-sea-blue: rgb(51, 99, 109);
  --col-darker-sea-blue-alpha: rgb(1, 64, 79, 0.7);
  --col-red-alpha: rgb(255, 0, 0, 0.5);

  /* Colors (background)*/
  --bg-col: var(--col-lighter-sea-blue);
  --gameboard-bg-col: var(--col-sea-blue);
  --cell-border-col: var(--col-darker-sea-blue-alpha);
  --cell-hit-col: var(--col-orange-light);
  --cell-miss-col: var(--col-white);
  --col-sunk-ship-overlay: var(--col-red-alpha);
  --orange-gradient: linear-gradient(
    var(--col-orange-light),
    var(--col-orange),
    var(--col-orange-dark)
  );
  --txt-bg-col: var(--col-black-alpha);

  /* Colors (text/icons)*/
  --col-txt: var(--col-black);
  --col-txt-alt: var(--col-white);
  --col-txt-accent: var(--col-orange);

  /* Font family */
  --main-font: "Passero One", monospace;
  --accent-font: "Labrada", serif;

  /* Font sizes */
  --txt-fontsize: 18px;
  --txt-lineheight: 1;
  --h1-fontsize: 1.2rem;
  --player-h3-fontsize: 1rem;
  --msg-fontsize: 1rem;
  --edit-instructions-fontsize: 0.8rem;
  --title-fontsize: 3.2rem;
  --subtitle-fontsize: 1.2rem;
  --button-fontsize: 1.5rem;
  --player-name-fontsize: 2rem;
  --player-title-fontsize: 1.5rem;
  --player-vs-fontsize: 1.5rem;
  --player-fontsize: 1rem;
  --player-name-fontsize: 1.2rem;
  --game-button-fontsize: 0.8rem;
  --footer-fontsize: 0.8rem;

  --fix-font-padding-bottom: 5px;

  /* Text clamping: number of lines */
  /* --max-lines: 4; */

  /* Maximum width (including dashboard margin) */
  --max-width: min(1440px, 100%);

  /* Radius */
  --button-radius: 0.25rem;

  /*Margins, gaps and paddings (+widths)*/
  --page-padding: min(1rem, 2vmin);
  --page-gap: min(1rem, 2vmin);
  --players-gap: min(2rem, 3vmin);
  --shadow-len: 0.75rem;
  --shadow-len-mark: calc(var(--shadow-len) / 4);
  --shadow-len-txt: calc(var(--shadow-len) / 4);
  --button-padding: 0.5rem;
  --button-padding-fixed: var(--button-padding) var(--button-padding)
    calc(var(--button-padding) + var(--fix-font-padding-bottom));
  --input-padding-bottom: 0.1em;
  --vs-padding: 2vmax;

  /* Images / icons size */

  /* Shadows */
  /* --outset-shadow: 2px 2px 8px var(--col-accent-medium);
    --outset-shadow-btn-active: 2px 2px 5px var(--col-accent-medium);
    --inset-shadow: 2px 2px 2px var(--col-accent-light) inset; */

  /* Animations on hover / active / ...*/
  --time-animation-btn: 0.2s;
  /* --time-animation: 0.4s; set via js in GameboardDom module */
}

/* ::backdrop { */
/* background-color: var(--col-black); */
/* opacity: 0.75; */
/* } */

html {
  background-color: var(--bg-col);
  color: var(--col-txt);
  font-family: var(--main-font), sans-serif;
  font-weight: 400;
  font-size: var(--txt-fontsize);
  line-height: var(--txt-lineheight);
  user-select: none;
}

*,
*:before,
*:after {
  font-family: inherit;
  font-size: inherit; /* 100% */
  line-height: inherit;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0 auto;
  min-height: 100vh; /*it is assumed the same for <html>*/
  min-height: 100dvh; /* if supported */

  /* if you want to allow scroll: */
  height: 100%;

  width: 100%;
  /* or max-width -- this avoids horizontal scroll bars */

  touch-action: manipulation; /* disable double tap to zoom on some browsers*/
  /* user-select: none; */

  background-color: var(--bg-col);
  background-attachment: fixed;
}

/*****************************************************/

/* || Generic */

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  height: 100vh; /*it is assumed the same for <html>*/
  height: 100dvh; /* if supported */
}

main > * {
  width: 100%;
}

/* .header-container, */
/* .main-container{ */
/* width: 100%; */
/* max-width: var(--max-width); */
/* margin: 0 auto; */
/* } */

/* main { */
/* width: 100%; */
/* max-width: var(--max-width); */
/* min-height: 100dvh; */
/* flex-shrink: 0; */
/* margin: 0 auto; */
/* } */

p {
  text-wrap: pretty; /*or balance */
}

ul,
ol {
  list-style: none;
}

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
}

button {
  cursor: pointer;
}

/* when hover is supporte */
@media not all and (hover: none) {
  /* styles*/
}

/* tablet or larger, or landscape (vs portrait), 641px (phone), 961px (tablet) */
@media only screen and (min-width: 768px), (orientation: landscape) {
}

/* Customize scrollbars */
::-webkit-scrollbar {
  width: 4px; /* width of the entire scrollbar */
  height: 4px; /* height of the entire scrollbar */
}

::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}

::-webkit-scrollbar-thumb {
  background: #888; /* color of the scroll thumb */
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555; /* color of the scroll thumb on hover */
}

/* Structural styles ----------------------------------------------------- */
.game,
.game-end,
.deploy-fleet,
.home,
.players-name,
.game__players-div,
.game__player-div,
.deploy-fleet__player-div,
.player {
  display: flex;
  flex-direction: column;
  flex: 1;
}

@media only screen and (orientation: landscape) {
  .game__players-div {
    flex-direction: row;
  }
}

.game,
.game__players-div,
.game__player-div,
.deploy-fleet,
.deploy-fleet__player-div,
.player,
.player__gameboard,
.cell {
  overflow: hidden;
  min-height: 0;
  min-width: 0;
}

.game__player-div,
.deploy-fleet__player-div {
  width: 100%;
  height: 100%;
  justify-content: center;
  /* border: 2px solid green; */
}

/* .player__gameboard { */
/* border: 2px solid red; */
/* } */

.player {
  justify-content: center;
}

.player__player-h3 {
  text-align: center;
}

.gameboard {
  max-height: 100%;
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

/* Colors, dimensions and padding styles --------------------------------- */

.game,
.game-end,
.deploy-fleet,
.home,
.players-name {
  padding: var(--page-padding);
  gap: var(--page-gap);
}

.game,
.game__players-div,
.deploy-fleet {
  gap: var(--players-gap);
}

@media only screen and (orientation: landscape) {
  .game,
  .deploy-fleet {
    gap: var(--page-gap);
  }
}

/* Custom Header style*/
.game__header,
.deploy-fleet__header {
  display: flex;
  justify-content: center;
}

.game__btns,
.deploy-fleet__btns {
  display: flex;
  gap: var(--players-gap);
}

.deploy-fleet__header button,
.game__header button {
  text-align: center;
  font-size: var(--game-button-fontsize);
  min-width: 7em;
}

/* Custom gameboard style */
.gameboard {
  padding: var(--shadow-len);
}

/* Custom player style */
.player__player-h3 {
  font-size: var(--player-h3-fontsize);
}

/* Custom cell style */
.cell {
  border: 1px solid var(--cell-border-col);
}

/* page view */
.game-end,
.home,
.players-name {
  align-items: center;
  justify-content: space-between;
  margin: 1rem auto 10vh;
}

/* players name view */
.players-name__players-cnt-div {
  display: grid;
  grid-template-rows: minmax(0, 1fr) min-content minmax(0, 1fr);
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
}

.players-name__player-div {
  background-color: var(--txt-bg-col);
  padding: var(--button-padding);
  border: none;
  border-radius: var(--button-radius);
  box-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.players-name__ai-player-div {
  display: grid;
  grid-template-columns: min-content 1fr min-content;
}

.players-name__prev-ai-btn,
.players-name__next-ai-btn {
  grid-row: 1 / span 2;
  font-size: var(--player-title-fontsize);
}

.players-name__prev-ai-btn:active,
.players-name__next-ai-btn:active {
  transform: scaleX(0.9);
}

.players-name__prev-ai-btn:disabled,
.players-name__next-ai-btn:disabled {
  opacity: 0;
  pointer-events: none;
}

@media not all and (hover: none) {
  .players-name__prev-ai-btn:hover,
  .players-name__next-ai-btn:hover {
    transform: scaleX(0.9);
  }
}

.players-name__prev-ai-btn {
  grid-column: 1;
}

.players-name__next-ai-btn {
  grid-column: 3;
}

.players-name__player-name-p,
.players-name__player-name-input,
.players-name__player-title-p,
.players-name__vs-p {
  color: var(--col-txt-alt);
  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
  text-align: center;
  vertical-align: middle;
}

.players-name__player-name-p,
.players-name__player-name-input {
  font-size: var(--player-name-fontsize);
  background: var(--orange-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(
    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)
  );
  text-shadow: none;
  font-weight: bold;
  height: calc(
    var(--txt-lineheight) * var(--player-name-fontsize) +
      var(--input-padding-bottom) + 2px
  );
}

.players-name__player-name-input {
  outline: none;
  border: none;
  border-bottom: 2px solid var(--col-txt-alt);
  background-color: transparent;
  padding-bottom: var(--input-padding-bottom);
  width: 80%;
}

.players-name__player-name-input::placeholder {
  color: var(--col-grey);
}

.players-name__player-name-input:focus {
  border-bottom-color: var(--col-txt-accent);
}

.players-name__player-title-p {
  font-size: var(--player-title-fontsize);
}

.players-name__vs-p {
  font-size: var(--player-vs-fontsize);
  font-family: var(--accent-font);
  padding: var(--vs-padding) 0
    calc(var(--fix-font-padding-bottom) + var(--vs-padding));
  font-weight: bold;
  opacity: 0.8;
}

@media only screen and (orientation: landscape) {
  .players-name__players-cnt-div {
    grid-template-columns: minmax(0, 1fr) min-content minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
  }

  .players-name__vs-p {
    padding: 0 var(--vs-padding) var(--fix-font-padding-bottom);
  }
}

/* backgrounds and shadows */
body,
.gameboard,
.hit-mark,
.miss-mark {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gameboard {
  background-color: var(--gameboard-bg-col);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow: 0px 0px var(--shadow-len) var(--col-black) inset;
}

body:has(.game-end.winner-2p) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
body:has(.game-end.defeated-1p) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
body:has(.game-end.winner-1p) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
body:has(.home),
body:has(.players-name) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
body:has(.game) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
body:has(.deploy-fleet) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.hit-mark {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  filter: drop-shadow(0 0 var(--shadow-len-mark) var(--cell-hit-col));
}
.miss-mark {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  filter: drop-shadow(0 0 var(--shadow-len-mark) var(--cell-miss-col));
}

/* Players info */
.player__player-h3 {
  color: var(--col-txt-alt);
  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
  font-weight: normal;
  padding-bottom: var(--fix-font-padding-bottom);
  font-size: var(--player-fontsize);
}

.player__name-span {
  font-family: var(--accent-font);
  font-size: var(--player-name-fontsize);
}

.currentPlayer .player__name-span {
  font-weight: bold;
  background: var(--orange-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(
    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)
  );
  text-shadow: none;
}

/* Custom msg p style*/
.game__msg-p,
.deploy-fleet__msg-p {
  text-align: center;
  font-size: var(--msg-fontsize);
  text-wrap: balance;
  color: var(--col-txt-alt);
  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
  margin-top: auto;
}

.game__msg-p.hidden {
  visibility: hidden;
}

.deploy-fleet__edit-instructions-p {
  text-align: center;
  font-size: var(--edit-instructions-fontsize);
  font-family: var(--accent-font);
  line-height: 1.2;
  text-wrap: balance;
  color: var(--col-grey);
}

/* Ships */
.ship {
  filter: drop-shadow(0 0 var(--shadow-len) var(--col-black));
}
.ship.sunk .ship__mask {
  background-color: var(--col-sunk-ship-overlay);
}

.shadow-ship {
  background-image: none !important;
}

.shadow-ship:not(.out-of-bound):not(.fallback) .ship__mask {
  display: block !important;
}

.gameboard:has(.ship.on-drag.forbidden-position)
  .shadow-ship.fallback
  .ship__mask {
  display: block !important;
}

.shadow-ship .ship__mask {
  background-color: var(--col-black-alpha);
}

.gameboard:has(.ship.on-drag.forbidden-position)
  .shadow-ship:not(.fallback)
  .ship__mask {
  background-color: var(--col-red-alpha);
}

/* Texts */
.game-end__title-h2,
.game-end__subtitle-p,
.home__title-h1,
.home__subtitle-p,
.players-name__title-h1,
.players-name__subtitle-p {
  text-align: center;
  text-wrap: balance;
}

.game-end__title-h2,
.home__title-h1,
.players-name__title-h1 {
  font-size: var(--title-fontsize);
  font-family: var(--accent-font);
  font-weight: bold;
  background: var(--orange-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(
    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)
  );
  line-height: 1;
  padding-bottom: 0.2em;
}

.game-end__subtitle-p,
.home__subtitle-p,
.players-name__subtitle-p {
  color: var(--col-txt-alt);
  font-size: var(--subtitle-fontsize);
  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
}

/* buttons */
button {
  padding: var(--button-padding-fixed);
  font-family: var(--accent-font);
  background: var(--orange-gradient);
  font-weight: bold;
  border: none;
  border-radius: var(--button-radius);
  font-size: var(--button-fontsize);
  transition: transform var(--time-animation-btn);
  box-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);
}

button:active {
  transform: translateY(-5px);
}

@media not all and (hover: none) {
  button:hover {
    transform: translateY(-5px);
  }
}

.home__players-btns {
  display: flex;
  gap: 1rem;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
}
.home__players-btns button,
.players-name__play-btn {
  width: 8em;
}

.gameboard.aiming .cell.hit,
.gameboard.aiming .cell.miss,
.gameboard.aiming .hit-mark,
.gameboard.aiming .miss-mark {
  cursor: not-allowed;
}
.gameboard.aiming .cell:not(.hit):not(.miss) {
  cursor: crosshair;
}

/* animation class */
.no-transition {
  transition: none !important;
}

.player__name-span {
  transition:
    color var(--time-animation),
    background-color var(--time-animation);
}

.miss-mark,
.hit-mark,
.ship {
  opacity: 1;
  transform: scale(1);
  transition:
    opacity var(--time-animation),
    transform var(--time-animation),
    background-color var(--time-animation);
  transition-timing-function: ease;
}

.miss-mark {
  transform: scale(0.6);
}

.ship {
  transition-timing-function: ease-in;
}

.miss-mark.initial-state,
.hit-mark.initial-state,
.ship.initial-state {
  opacity: 0;
  transform: scale(1);
}

.hit-mark.initial-state {
  transform: scale(2);
}

.miss-mark.initial-state {
  transform: scale(0.3);
}

.ship.initial-state {
  transition-timing-function: ease-out;
}

/* editing the deployed ship */

.gameboard:has(.ship.on-drag) {
  cursor: move;
}

.gameboard:has(.ship.on-drag.forbidden-position),
body:has(.ship.on-drag.forbidden-position) {
  cursor: not-allowed;
}

@media not all and (hover: none) {
  .deploy-fleet:not(:has(.ship.on-drag)) .ship:hover {
    cursor: pointer;
  }
}

.ship.on-drag {
  z-index: 100 !important; /*set it on top of everything*/
  transition-timing-function: ease-out;
  filter: drop-shadow(0 0 calc(0.5 * var(--shadow-len)) var(--col-black));
}

/* main footer */

.main-footer {
  background-color: var(--col-black-alpha);
  color: var(--col-grey);
  font-weight: normal;
  font-family: var(--accent-font);
  font-size: var(--footer-fontsize);
  padding: var(--page-padding);
}

.main-footer__p {
  max-width: min(100%, 50rem);
  padding: var(--page-padding) 0
    calc(var(--page-padding) + var(--fix-font-padding-bottom));
  margin: 0 auto;
  text-align: center;
  text-wrap: balance;
}

.main-footer__p a {
  /* text-shadow: 2px 2px 2px var(--col-black); */
  color: var(--col-white);
}

@media not all and (hover: none) {
  .main-footer__p a:hover {
    cursor: pointer;
    color: var(--col-txt-accent);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;EAEE,oBAAoB;EACpB,4BAA4B;EAC5B,uCAAuC;EACvC,mCAAmC;EACnC,+BAA+B;EAC/B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,qCAAqC,EAAE,SAAS;EAChD,8BAA8B;EAC9B,wCAAwC;EACxC,gDAAgD;EAChD,oCAAoC;;EAEpC,uBAAuB;EACvB,qCAAqC;EACrC,uCAAuC;EACvC,mDAAmD;EACnD,uCAAuC;EACvC,iCAAiC;EACjC,6CAA6C;EAC7C;;;;GAIC;EACD,oCAAoC;;EAEpC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,mCAAmC;;EAEnC,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;;EAE/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;;EAEzB,8BAA8B;;EAE9B,mCAAmC;EACnC,oBAAoB;;EAEpB,+CAA+C;EAC/C,8BAA8B;;EAE9B,WAAW;EACX,wBAAwB;;EAExB,uCAAuC;EACvC,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;EAC/B,qBAAqB;EACrB,8CAA8C;EAC9C,6CAA6C;EAC7C,wBAAwB;EACxB;gEAC8D;EAC9D,6BAA6B;EAC7B,mBAAmB;;EAEnB,wBAAwB;;EAExB,YAAY;EACZ;;gEAE8D;;EAE9D,sCAAsC;EACtC,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA,iBAAiB;AACjB,wCAAwC;AACxC,mBAAmB;AACnB,MAAM;;AAEN;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB,EAAE,oCAAoC;EACvD,kBAAkB,EAAE,iBAAiB;;EAErC,iCAAiC;EACjC,YAAY;;EAEZ,WAAW;EACX,uDAAuD;;EAEvD,0BAA0B,EAAE,+CAA+C;EAC3E,uBAAuB;;EAEvB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,sDAAsD;;AAEtD,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;;EAEd,aAAa,EAAE,oCAAoC;EACnD,cAAc,EAAE,iBAAiB;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB,qBAAqB;AACrB,iBAAiB;AACjB,iCAAiC;AACjC,oBAAoB;AACpB,MAAM;;AAEN,WAAW;AACX,iBAAiB;AACjB,iCAAiC;AACjC,wBAAwB;AACxB,oBAAoB;AACpB,oBAAoB;AACpB,MAAM;;AAEN;EACE,iBAAiB,EAAE,cAAc;AACnC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA,gFAAgF;AAChF;AACA;;AAEA,yBAAyB;AACzB;EACE,UAAU,EAAE,kCAAkC;EAC9C,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA,4EAA4E;AAC5E;;;;;;;;;EASE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB,2BAA2B;AAC3B,MAAM;;AAEN;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,4EAA4E;;AAE5E;;;;;EAKE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,oBAAoB;EACtB;AACF;;AAEA,uBAAuB;AACvB;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;AAC1C;;AAEA,cAAc;AACd;;;EAGE,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,6DAA6D;EAC7D,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,mCAAmC;EACnC,wEAAwE;EACxE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;;EAEE,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,yEAAyE;EACzE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB;;GAEC;EACD,iBAAiB;EACjB,iBAAiB;EACjB;;;GAGC;AACH;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,6BAA6B;EAC7B,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B;4DAC0D;EAC1D,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,gEAAgE;IAChE,kCAAkC;EACpC;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA,4BAA4B;AAC5B;;;;EAIE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,yDAA4D;EAC5D,4DAA4D;AAC9D;;AAEA;EACE,yDAAkE;AACpE;AACA;EACE,yDAAoE;AACtE;AACA;EACE,yDAAkE;AACpE;AACA;;EAEE,yDAA6D;AAC/D;AACA;EACE,yDAA+D;AACjE;AACA;EACE,yDAAqE;AACvE;;AAEA;EACE,yDAA+D;EAC/D,mEAAmE;AACrE;AACA;EACE,yDAAgE;EAChE,oEAAoE;AACtE;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,yEAAyE;EACzE,mBAAmB;EACnB,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB;;GAEC;EACD,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,2DAA2D;AAC7D;AACA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA,UAAU;AACV;;;;;;EAME,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB;;GAEC;EACD,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,mCAAmC;EACnC,yEAAyE;AAC3E;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,kCAAkC;EAClC,iBAAiB;EACjB,YAAY;EACZ,mCAAmC;EACnC,iCAAiC;EACjC,+CAA+C;EAC/C,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;AAC7B;;AAEA;EACE;;0CAEwC;AAC1C;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;EACnB;;;0CAGwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;;AAE9B;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB,EAAE,8BAA8B;EACvD,oCAAoC;EACpC,uEAAuE;AACzE;;AAEA,gBAAgB;;AAEhB;EACE,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B;8DAC4D;EAC5D,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,4BAA4B;EAC9B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Passero+One&family=Labrada&display=swap\");\r\n\r\n:root,\r\n::backdrop {\r\n  /* Colors (palette)*/\r\n  --col-black: rgb(20, 20, 20);\r\n  --col-black-alpha: rgb(20, 20, 20, 0.5);\r\n  --col-grey: rgb(200, 200, 200, 0.8);\r\n  --col-white: rgb(255, 255, 255);\r\n  --col-orange-dark: rgb(224, 60, 36);\r\n  --col-orange-light: rgb(249, 167, 34);\r\n  --col-orange: rgb(245, 117, 16);\r\n  --col-darker-sea-blue: rgb(1, 64, 79); /*014e65*/\r\n  --col-sea-blue: rgb(6, 70, 84);\r\n  --col-lighter-sea-blue: rgb(51, 99, 109);\r\n  --col-darker-sea-blue-alpha: rgb(1, 64, 79, 0.7);\r\n  --col-red-alpha: rgb(255, 0, 0, 0.5);\r\n\r\n  /* Colors (background)*/\r\n  --bg-col: var(--col-lighter-sea-blue);\r\n  --gameboard-bg-col: var(--col-sea-blue);\r\n  --cell-border-col: var(--col-darker-sea-blue-alpha);\r\n  --cell-hit-col: var(--col-orange-light);\r\n  --cell-miss-col: var(--col-white);\r\n  --col-sunk-ship-overlay: var(--col-red-alpha);\r\n  --orange-gradient: linear-gradient(\r\n    var(--col-orange-light),\r\n    var(--col-orange),\r\n    var(--col-orange-dark)\r\n  );\r\n  --txt-bg-col: var(--col-black-alpha);\r\n\r\n  /* Colors (text/icons)*/\r\n  --col-txt: var(--col-black);\r\n  --col-txt-alt: var(--col-white);\r\n  --col-txt-accent: var(--col-orange);\r\n\r\n  /* Font family */\r\n  --main-font: \"Passero One\", monospace;\r\n  --accent-font: \"Labrada\", serif;\r\n\r\n  /* Font sizes */\r\n  --txt-fontsize: 18px;\r\n  --txt-lineheight: 1;\r\n  --h1-fontsize: 1.2rem;\r\n  --player-h3-fontsize: 1rem;\r\n  --msg-fontsize: 1rem;\r\n  --edit-instructions-fontsize: 0.8rem;\r\n  --title-fontsize: 3.2rem;\r\n  --subtitle-fontsize: 1.2rem;\r\n  --button-fontsize: 1.5rem;\r\n  --player-name-fontsize: 2rem;\r\n  --player-title-fontsize: 1.5rem;\r\n  --player-vs-fontsize: 1.5rem;\r\n  --player-fontsize: 1rem;\r\n  --player-name-fontsize: 1.2rem;\r\n  --game-button-fontsize: 0.8rem;\r\n  --footer-fontsize: 0.8rem;\r\n\r\n  --fix-font-padding-bottom: 5px;\r\n\r\n  /* Text clamping: number of lines */\r\n  /* --max-lines: 4; */\r\n\r\n  /* Maximum width (including dashboard margin) */\r\n  --max-width: min(1440px, 100%);\r\n\r\n  /* Radius */\r\n  --button-radius: 0.25rem;\r\n\r\n  /*Margins, gaps and paddings (+widths)*/\r\n  --page-padding: min(1rem, 2vmin);\r\n  --page-gap: min(1rem, 2vmin);\r\n  --players-gap: min(2rem, 3vmin);\r\n  --shadow-len: 0.75rem;\r\n  --shadow-len-mark: calc(var(--shadow-len) / 4);\r\n  --shadow-len-txt: calc(var(--shadow-len) / 4);\r\n  --button-padding: 0.5rem;\r\n  --button-padding-fixed: var(--button-padding) var(--button-padding)\r\n    calc(var(--button-padding) + var(--fix-font-padding-bottom));\r\n  --input-padding-bottom: 0.1em;\r\n  --vs-padding: 2vmax;\r\n\r\n  /* Images / icons size */\r\n\r\n  /* Shadows */\r\n  /* --outset-shadow: 2px 2px 8px var(--col-accent-medium);\r\n    --outset-shadow-btn-active: 2px 2px 5px var(--col-accent-medium);\r\n    --inset-shadow: 2px 2px 2px var(--col-accent-light) inset; */\r\n\r\n  /* Animations on hover / active / ...*/\r\n  --time-animation-btn: 0.2s;\r\n  /* --time-animation: 0.4s; set via js in GameboardDom module */\r\n}\r\n\r\n/* ::backdrop { */\r\n/* background-color: var(--col-black); */\r\n/* opacity: 0.75; */\r\n/* } */\r\n\r\nhtml {\r\n  background-color: var(--bg-col);\r\n  color: var(--col-txt);\r\n  font-family: var(--main-font), sans-serif;\r\n  font-weight: 400;\r\n  font-size: var(--txt-fontsize);\r\n  line-height: var(--txt-lineheight);\r\n  user-select: none;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  font-family: inherit;\r\n  font-size: inherit; /* 100% */\r\n  line-height: inherit;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n  vertical-align: baseline;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  margin: 0 auto;\r\n  min-height: 100vh; /*it is assumed the same for <html>*/\r\n  min-height: 100dvh; /* if supported */\r\n\r\n  /* if you want to allow scroll: */\r\n  height: 100%;\r\n\r\n  width: 100%;\r\n  /* or max-width -- this avoids horizontal scroll bars */\r\n\r\n  touch-action: manipulation; /* disable double tap to zoom on some browsers*/\r\n  /* user-select: none; */\r\n\r\n  background-color: var(--bg-col);\r\n  background-attachment: fixed;\r\n}\r\n\r\n/*****************************************************/\r\n\r\n/* || Generic */\r\n\r\nmain {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  overflow: auto;\r\n\r\n  height: 100vh; /*it is assumed the same for <html>*/\r\n  height: 100dvh; /* if supported */\r\n}\r\n\r\nmain > * {\r\n  width: 100%;\r\n}\r\n\r\n/* .header-container, */\r\n/* .main-container{ */\r\n/* width: 100%; */\r\n/* max-width: var(--max-width); */\r\n/* margin: 0 auto; */\r\n/* } */\r\n\r\n/* main { */\r\n/* width: 100%; */\r\n/* max-width: var(--max-width); */\r\n/* min-height: 100dvh; */\r\n/* flex-shrink: 0; */\r\n/* margin: 0 auto; */\r\n/* } */\r\n\r\np {\r\n  text-wrap: pretty; /*or balance */\r\n}\r\n\r\nul,\r\nol {\r\n  list-style: none;\r\n}\r\n\r\na,\r\na:hover,\r\na:active,\r\na:visited {\r\n  text-decoration: none;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\n/* when hover is supporte */\r\n@media not all and (hover: none) {\r\n  /* styles*/\r\n}\r\n\r\n/* tablet or larger, or landscape (vs portrait), 641px (phone), 961px (tablet) */\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n}\r\n\r\n/* Customize scrollbars */\r\n::-webkit-scrollbar {\r\n  width: 4px; /* width of the entire scrollbar */\r\n  height: 4px; /* height of the entire scrollbar */\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent; /* color of the tracking area */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #888; /* color of the scroll thumb */\r\n  border-radius: 2px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555; /* color of the scroll thumb on hover */\r\n}\r\n\r\n/* Structural styles ----------------------------------------------------- */\r\n.game,\r\n.game-end,\r\n.deploy-fleet,\r\n.home,\r\n.players-name,\r\n.game__players-div,\r\n.game__player-div,\r\n.deploy-fleet__player-div,\r\n.player {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n}\r\n\r\n@media only screen and (orientation: landscape) {\r\n  .game__players-div {\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n.game,\r\n.game__players-div,\r\n.game__player-div,\r\n.deploy-fleet,\r\n.deploy-fleet__player-div,\r\n.player,\r\n.player__gameboard,\r\n.cell {\r\n  overflow: hidden;\r\n  min-height: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.game__player-div,\r\n.deploy-fleet__player-div {\r\n  width: 100%;\r\n  height: 100%;\r\n  justify-content: center;\r\n  /* border: 2px solid green; */\r\n}\r\n\r\n/* .player__gameboard { */\r\n/* border: 2px solid red; */\r\n/* } */\r\n\r\n.player {\r\n  justify-content: center;\r\n}\r\n\r\n.player__player-h3 {\r\n  text-align: center;\r\n}\r\n\r\n.gameboard {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Colors, dimensions and padding styles --------------------------------- */\r\n\r\n.game,\r\n.game-end,\r\n.deploy-fleet,\r\n.home,\r\n.players-name {\r\n  padding: var(--page-padding);\r\n  gap: var(--page-gap);\r\n}\r\n\r\n.game,\r\n.game__players-div,\r\n.deploy-fleet {\r\n  gap: var(--players-gap);\r\n}\r\n\r\n@media only screen and (orientation: landscape) {\r\n  .game,\r\n  .deploy-fleet {\r\n    gap: var(--page-gap);\r\n  }\r\n}\r\n\r\n/* Custom Header style*/\r\n.game__header,\r\n.deploy-fleet__header {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.game__btns,\r\n.deploy-fleet__btns {\r\n  display: flex;\r\n  gap: var(--players-gap);\r\n}\r\n\r\n.deploy-fleet__header button,\r\n.game__header button {\r\n  text-align: center;\r\n  font-size: var(--game-button-fontsize);\r\n  min-width: 7em;\r\n}\r\n\r\n/* Custom gameboard style */\r\n.gameboard {\r\n  padding: var(--shadow-len);\r\n}\r\n\r\n/* Custom player style */\r\n.player__player-h3 {\r\n  font-size: var(--player-h3-fontsize);\r\n}\r\n\r\n/* Custom cell style */\r\n.cell {\r\n  border: 1px solid var(--cell-border-col);\r\n}\r\n\r\n/* page view */\r\n.game-end,\r\n.home,\r\n.players-name {\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin: 1rem auto 10vh;\r\n}\r\n\r\n/* players name view */\r\n.players-name__players-cnt-div {\r\n  display: grid;\r\n  grid-template-rows: minmax(0, 1fr) min-content minmax(0, 1fr);\r\n  grid-template-columns: minmax(0, 1fr);\r\n  align-items: center;\r\n}\r\n\r\n.players-name__player-div {\r\n  background-color: var(--txt-bg-col);\r\n  padding: var(--button-padding);\r\n  border: none;\r\n  border-radius: var(--button-radius);\r\n  box-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.players-name__ai-player-div {\r\n  display: grid;\r\n  grid-template-columns: min-content 1fr min-content;\r\n}\r\n\r\n.players-name__prev-ai-btn,\r\n.players-name__next-ai-btn {\r\n  grid-row: 1 / span 2;\r\n  font-size: var(--player-title-fontsize);\r\n}\r\n\r\n.players-name__prev-ai-btn:active,\r\n.players-name__next-ai-btn:active {\r\n  transform: scaleX(0.9);\r\n}\r\n\r\n.players-name__prev-ai-btn:disabled,\r\n.players-name__next-ai-btn:disabled {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  .players-name__prev-ai-btn:hover,\r\n  .players-name__next-ai-btn:hover {\r\n    transform: scaleX(0.9);\r\n  }\r\n}\r\n\r\n.players-name__prev-ai-btn {\r\n  grid-column: 1;\r\n}\r\n\r\n.players-name__next-ai-btn {\r\n  grid-column: 3;\r\n}\r\n\r\n.players-name__player-name-p,\r\n.players-name__player-name-input,\r\n.players-name__player-title-p,\r\n.players-name__vs-p {\r\n  color: var(--col-txt-alt);\r\n  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.players-name__player-name-p,\r\n.players-name__player-name-input {\r\n  font-size: var(--player-name-fontsize);\r\n  background: var(--orange-gradient);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n  filter: drop-shadow(\r\n    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)\r\n  );\r\n  text-shadow: none;\r\n  font-weight: bold;\r\n  height: calc(\r\n    var(--txt-lineheight) * var(--player-name-fontsize) +\r\n      var(--input-padding-bottom) + 2px\r\n  );\r\n}\r\n\r\n.players-name__player-name-input {\r\n  outline: none;\r\n  border: none;\r\n  border-bottom: 2px solid var(--col-txt-alt);\r\n  background-color: transparent;\r\n  padding-bottom: var(--input-padding-bottom);\r\n  width: 80%;\r\n}\r\n\r\n.players-name__player-name-input::placeholder {\r\n  color: var(--col-grey);\r\n}\r\n\r\n.players-name__player-name-input:focus {\r\n  border-bottom-color: var(--col-txt-accent);\r\n}\r\n\r\n.players-name__player-title-p {\r\n  font-size: var(--player-title-fontsize);\r\n}\r\n\r\n.players-name__vs-p {\r\n  font-size: var(--player-vs-fontsize);\r\n  font-family: var(--accent-font);\r\n  padding: var(--vs-padding) 0\r\n    calc(var(--fix-font-padding-bottom) + var(--vs-padding));\r\n  font-weight: bold;\r\n  opacity: 0.8;\r\n}\r\n\r\n@media only screen and (orientation: landscape) {\r\n  .players-name__players-cnt-div {\r\n    grid-template-columns: minmax(0, 1fr) min-content minmax(0, 1fr);\r\n    grid-template-rows: minmax(0, 1fr);\r\n  }\r\n\r\n  .players-name__vs-p {\r\n    padding: 0 var(--vs-padding) var(--fix-font-padding-bottom);\r\n  }\r\n}\r\n\r\n/* backgrounds and shadows */\r\nbody,\r\n.gameboard,\r\n.hit-mark,\r\n.miss-mark {\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.gameboard {\r\n  background-color: var(--gameboard-bg-col);\r\n  background-image: url(\"./assets/images/backgrounds/sea.jpg\");\r\n  box-shadow: 0px 0px var(--shadow-len) var(--col-black) inset;\r\n}\r\n\r\nbody:has(.game-end.winner-2p) {\r\n  background-image: url(\"./assets/images/backgrounds/winner-2p.jpg\");\r\n}\r\nbody:has(.game-end.defeated-1p) {\r\n  background-image: url(\"./assets/images/backgrounds/defeated-1p.jpg\");\r\n}\r\nbody:has(.game-end.winner-1p) {\r\n  background-image: url(\"./assets/images/backgrounds/winner-1p.jpg\");\r\n}\r\nbody:has(.home),\r\nbody:has(.players-name) {\r\n  background-image: url(\"./assets/images/backgrounds/home.jpg\");\r\n}\r\nbody:has(.game) {\r\n  background-image: url(\"./assets/images/backgrounds/battle.jpg\");\r\n}\r\nbody:has(.deploy-fleet) {\r\n  background-image: url(\"./assets/images/backgrounds/deploy-fleet.jpg\");\r\n}\r\n\r\n.hit-mark {\r\n  background-image: url(\"./assets/images/hit_miss_marks/hit.png\");\r\n  filter: drop-shadow(0 0 var(--shadow-len-mark) var(--cell-hit-col));\r\n}\r\n.miss-mark {\r\n  background-image: url(\"./assets/images/hit_miss_marks/miss.png\");\r\n  filter: drop-shadow(0 0 var(--shadow-len-mark) var(--cell-miss-col));\r\n}\r\n\r\n/* Players info */\r\n.player__player-h3 {\r\n  color: var(--col-txt-alt);\r\n  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n  font-weight: normal;\r\n  padding-bottom: var(--fix-font-padding-bottom);\r\n  font-size: var(--player-fontsize);\r\n}\r\n\r\n.player__name-span {\r\n  font-family: var(--accent-font);\r\n  font-size: var(--player-name-fontsize);\r\n}\r\n\r\n.currentPlayer .player__name-span {\r\n  font-weight: bold;\r\n  background: var(--orange-gradient);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n  filter: drop-shadow(\r\n    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)\r\n  );\r\n  text-shadow: none;\r\n}\r\n\r\n/* Custom msg p style*/\r\n.game__msg-p,\r\n.deploy-fleet__msg-p {\r\n  text-align: center;\r\n  font-size: var(--msg-fontsize);\r\n  text-wrap: balance;\r\n  color: var(--col-txt-alt);\r\n  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n  margin-top: auto;\r\n}\r\n\r\n.game__msg-p.hidden {\r\n  visibility: hidden;\r\n}\r\n\r\n.deploy-fleet__edit-instructions-p {\r\n  text-align: center;\r\n  font-size: var(--edit-instructions-fontsize);\r\n  font-family: var(--accent-font);\r\n  line-height: 1.2;\r\n  text-wrap: balance;\r\n  color: var(--col-grey);\r\n}\r\n\r\n/* Ships */\r\n.ship {\r\n  filter: drop-shadow(0 0 var(--shadow-len) var(--col-black));\r\n}\r\n.ship.sunk .ship__mask {\r\n  background-color: var(--col-sunk-ship-overlay);\r\n}\r\n\r\n.shadow-ship {\r\n  background-image: none !important;\r\n}\r\n\r\n.shadow-ship:not(.out-of-bound):not(.fallback) .ship__mask {\r\n  display: block !important;\r\n}\r\n\r\n.gameboard:has(.ship.on-drag.forbidden-position)\r\n  .shadow-ship.fallback\r\n  .ship__mask {\r\n  display: block !important;\r\n}\r\n\r\n.shadow-ship .ship__mask {\r\n  background-color: var(--col-black-alpha);\r\n}\r\n\r\n.gameboard:has(.ship.on-drag.forbidden-position)\r\n  .shadow-ship:not(.fallback)\r\n  .ship__mask {\r\n  background-color: var(--col-red-alpha);\r\n}\r\n\r\n/* Texts */\r\n.game-end__title-h2,\r\n.game-end__subtitle-p,\r\n.home__title-h1,\r\n.home__subtitle-p,\r\n.players-name__title-h1,\r\n.players-name__subtitle-p {\r\n  text-align: center;\r\n  text-wrap: balance;\r\n}\r\n\r\n.game-end__title-h2,\r\n.home__title-h1,\r\n.players-name__title-h1 {\r\n  font-size: var(--title-fontsize);\r\n  font-family: var(--accent-font);\r\n  font-weight: bold;\r\n  background: var(--orange-gradient);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  color: transparent;\r\n  filter: drop-shadow(\r\n    0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt)\r\n  );\r\n  line-height: 1;\r\n  padding-bottom: 0.2em;\r\n}\r\n\r\n.game-end__subtitle-p,\r\n.home__subtitle-p,\r\n.players-name__subtitle-p {\r\n  color: var(--col-txt-alt);\r\n  font-size: var(--subtitle-fontsize);\r\n  text-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n}\r\n\r\n/* buttons */\r\nbutton {\r\n  padding: var(--button-padding-fixed);\r\n  font-family: var(--accent-font);\r\n  background: var(--orange-gradient);\r\n  font-weight: bold;\r\n  border: none;\r\n  border-radius: var(--button-radius);\r\n  font-size: var(--button-fontsize);\r\n  transition: transform var(--time-animation-btn);\r\n  box-shadow: 0 var(--shadow-len-txt) var(--shadow-len-txt) var(--col-txt);\r\n}\r\n\r\nbutton:active {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  button:hover {\r\n    transform: translateY(-5px);\r\n  }\r\n}\r\n\r\n.home__players-btns {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: space-evenly;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n.home__players-btns button,\r\n.players-name__play-btn {\r\n  width: 8em;\r\n}\r\n\r\n.gameboard.aiming .cell.hit,\r\n.gameboard.aiming .cell.miss,\r\n.gameboard.aiming .hit-mark,\r\n.gameboard.aiming .miss-mark {\r\n  cursor: not-allowed;\r\n}\r\n.gameboard.aiming .cell:not(.hit):not(.miss) {\r\n  cursor: crosshair;\r\n}\r\n\r\n/* animation class */\r\n.no-transition {\r\n  transition: none !important;\r\n}\r\n\r\n.player__name-span {\r\n  transition:\r\n    color var(--time-animation),\r\n    background-color var(--time-animation);\r\n}\r\n\r\n.miss-mark,\r\n.hit-mark,\r\n.ship {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n  transition:\r\n    opacity var(--time-animation),\r\n    transform var(--time-animation),\r\n    background-color var(--time-animation);\r\n  transition-timing-function: ease;\r\n}\r\n\r\n.miss-mark {\r\n  transform: scale(0.6);\r\n}\r\n\r\n.ship {\r\n  transition-timing-function: ease-in;\r\n}\r\n\r\n.miss-mark.initial-state,\r\n.hit-mark.initial-state,\r\n.ship.initial-state {\r\n  opacity: 0;\r\n  transform: scale(1);\r\n}\r\n\r\n.hit-mark.initial-state {\r\n  transform: scale(2);\r\n}\r\n\r\n.miss-mark.initial-state {\r\n  transform: scale(0.3);\r\n}\r\n\r\n.ship.initial-state {\r\n  transition-timing-function: ease-out;\r\n}\r\n\r\n/* editing the deployed ship */\r\n\r\n.gameboard:has(.ship.on-drag) {\r\n  cursor: move;\r\n}\r\n\r\n.gameboard:has(.ship.on-drag.forbidden-position),\r\nbody:has(.ship.on-drag.forbidden-position) {\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  .deploy-fleet:not(:has(.ship.on-drag)) .ship:hover {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.ship.on-drag {\r\n  z-index: 100 !important; /*set it on top of everything*/\r\n  transition-timing-function: ease-out;\r\n  filter: drop-shadow(0 0 calc(0.5 * var(--shadow-len)) var(--col-black));\r\n}\r\n\r\n/* main footer */\r\n\r\n.main-footer {\r\n  background-color: var(--col-black-alpha);\r\n  color: var(--col-grey);\r\n  font-weight: normal;\r\n  font-family: var(--accent-font);\r\n  font-size: var(--footer-fontsize);\r\n  padding: var(--page-padding);\r\n}\r\n\r\n.main-footer__p {\r\n  max-width: min(100%, 50rem);\r\n  padding: var(--page-padding) 0\r\n    calc(var(--page-padding) + var(--fix-font-padding-bottom));\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  text-wrap: balance;\r\n}\r\n\r\n.main-footer__p a {\r\n  /* text-shadow: 2px 2px 2px var(--col-black); */\r\n  color: var(--col-white);\r\n}\r\n\r\n@media not all and (hover: none) {\r\n  .main-footer__p a:hover {\r\n    cursor: pointer;\r\n    color: var(--col-txt-accent);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
